import { useMutation } from '@tanstack/react-query'
import { multiFactorAuthorizationRequest } from 'services/MFAService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { MultiFactorAuthorizationRequest } from 'types/mfa'

export const useMFAMutation = (onError?: (error: BaseErrorResponse, data: MultiFactorAuthorizationRequest) => void) => {
  return useMutation({
    mutationFn: (data: MultiFactorAuthorizationRequest) => multiFactorAuthorizationRequest(data),
    onError,
  })
}
